import * as React from "react";
import SkillBar from "react-skillbars";
import skills from "../../../data/skills";

class Skills extends React.Component {
  componentDidMount() {
    var list = document.getElementsByClassName("skillbar-bar");
    [].forEach.call(list, function (el) {
      el.classList.remove("collapsed");
    });
  }

  render() {
    const colors = {
      bar: "#26a6c4",
      title: {
        text: "#fff",
        background: "#19577d",
      },
    };
    const middleIndex = Math.ceil(skills.length / 2);
    const skillsLeft = skills.splice(0, middleIndex);
    const skillsRight = skills.splice(-middleIndex);
    return (
      <div className="skills">
        <div className="skills-title">Skills</div>
        <div className="skills-list">
          <div className="skills-list-left">
            <SkillBar
              skills={skillsLeft}
              height={24}
              colors={colors}
              animationDelay={0}
            />
          </div>
          <div className="skills-list-right">
            <SkillBar
              skills={skillsRight}
              height={24}
              colors={colors}
              animationDelay={0}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Skills;
